import apis from '../apis';

/** 用户登录 */
export const POST_LOGIN = apis.api + '/admin/login';
/** 获取当前登录用户的用户信息 */
export const GET_USER_INFO = apis.api + '/admin/user/info';
/** 刷新token */
export const GET_NEW_TOKEN = apis.api + '/admin/login/new_access_token';
/** 获取操作日志 */
export const GET_OPERATION_LOG = apis.api + '/admin/operate/log/list';
/** 通用上传 */
export const POST_UPLOAD = apis.api + '/common/file/public/upload';
// 修改密码
export const EDIT_PASSWORD = apis.api + '/admin/fire/user/pwd/edit';

// 企业微信登录
export const WECHAT_WORK_LOGIN = apis.api + '/admin/wecom-code-login';

// 组织部门树
export const DEPARTMEN_TTREE = apis.api + '/admin/department/tree';

// 员工
export const EMPLOYEE = apis.api + '/admin/employee';

// 项目经理
export const PROJECT_MANAGER = apis.api + '/admin/employee';

// 项目总监
export const PROJECT_DIRECTOR = apis.api + '/admin/employee';

// 阿里云oss签名
export const OSS_SIGNATURE = apis.api + '/oss-signature';

